import { itemStatuses, type ItemStatus } from './inventory';

export type StatusFamily =
  | 'data-quality'
  | 'procurement'
  | 'logistics'
  | 'deployed'
  | 'service'
  | 'return'
  | 'storage'
  | 'end-of-life';

export const statusLabels: Record<ItemStatus, string> = {
  STATUS_UNSPECIFIED: 'Status missing',
  ORDERED: 'Ordered',
  BUILD_IN_PROGRESS: 'Build in progress',
  SHIPPED_TO_WAREHOUSE: 'Shipped to warehouse',
  DELIVERED_TO_WAREHOUSE: 'Delivered to warehouse',
  FIELD_VALIDATION: 'Field validation',
  SHIPPED_TO_CUSTOMER: 'Shipped to customer',
  DELIVERED_TO_CUSTOMER: 'Delivered to customer',
  ACTIVE: 'Active',
  RMA_IN_PROGRESS: 'RMA in progress',
  MAINTENANCE_IN_PROGRESS: 'Maintenance in progress',
  RETURN_STARTED: 'Return started',
  RETURN_SHIPPED_TO_WAREHOUSE: 'Return shipped to warehouse',
  RETURN_DELIVERED_TO_WAREHOUSE: 'Return delivered to warehouse',
  IN_WAREHOUSE_STORAGE: 'In warehouse storage',
  NEEDS_REPAIR: 'Needs repair',
  SCRAP: 'Scrap',
  READY_TO_SHIP: 'Ready to ship',
  CLEANING: 'Cleaning',
  EOL_TESTING: 'End-of-line testing',
  REPLACED: 'Replaced (awaiting return)',
};

export const statusFamilies: Record<ItemStatus, StatusFamily> = {
  STATUS_UNSPECIFIED: 'data-quality',
  ORDERED: 'procurement',
  BUILD_IN_PROGRESS: 'procurement',
  SHIPPED_TO_WAREHOUSE: 'logistics',
  DELIVERED_TO_WAREHOUSE: 'logistics',
  SHIPPED_TO_CUSTOMER: 'logistics',
  DELIVERED_TO_CUSTOMER: 'logistics',
  READY_TO_SHIP: 'logistics',
  FIELD_VALIDATION: 'deployed',
  ACTIVE: 'deployed',
  RMA_IN_PROGRESS: 'service',
  MAINTENANCE_IN_PROGRESS: 'service',
  NEEDS_REPAIR: 'service',
  CLEANING: 'service',
  RETURN_STARTED: 'return',
  RETURN_SHIPPED_TO_WAREHOUSE: 'return',
  RETURN_DELIVERED_TO_WAREHOUSE: 'return',
  IN_WAREHOUSE_STORAGE: 'storage',
  EOL_TESTING: 'service',
  // Out of service at the customer, waiting to come back (tidaltech/koi#8447).
  REPLACED: 'return',
  SCRAP: 'end-of-life',
};

export function statusesForFamily(family: StatusFamily): ItemStatus[] {
  return itemStatuses.filter((status) => statusFamilies[status] === family);
}
